import type { CareerUpApplicationStep } from './careerUpApplicationTypes';

export function stepQuestionKey(stepId: CareerUpApplicationStep): string {
  return `submitDocuments.careerUpApplication.steps.${stepId}`;
}

export function applicationSummaryBubbleText(t: (key: string) => string): string {
  return [
    t('submitDocuments.careerUpApplication.summaryLine1'),
    t('submitDocuments.careerUpApplication.summaryLine2'),
    t('submitDocuments.careerUpApplication.agreePrompt'),
  ].join('\n\n');
}
